export default __webpack_public_path__ + "../staticImages/newsletter-5euro.jpg";